import React from 'react'
import ReportCalendarSidebar from './Sidebar/ReportCalendarSidebar'
import '../styles/report-calendar-left-part.sass'

const LeftPart = ({
	selectedDate,
	onSelectedDateChange,
	onViewMonthChange,
	events,
	isLoading,
}) => {
	return (
		<div className='reporting-calendar-left-part'>
			<ReportCalendarSidebar
				selectedDate={selectedDate}
				onSelectedDateChange={onSelectedDateChange}
				onViewMonthChange={onViewMonthChange}
				events={events}
				isLoading={isLoading}
			/>
		</div>
	)
}

export default LeftPart
